import { Configuration, EndSessionRequest, LogLevel } from '@azure/msal-browser';

export const azureAdScopes: string[] = ['openid', 'offline_access', 'profile'].concat(
    (process.env.REACT_APP_AAD_API_SCOPE as string) ? [process.env.REACT_APP_AAD_API_SCOPE as string] : [],
);


export const teamsAzureAdScopes: string[] = (process.env.REACT_APP_AAD_API_SCOPE as string)
    ? [process.env.REACT_APP_AAD_API_SCOPE as string]
    : ['openid', 'profile'];

export const nexusAzureAdScopes: string[] = (process.env.REACT_APP_AAD_API_SCOPE_NEXUS as string)
    ? [process.env.REACT_APP_AAD_API_SCOPE_NEXUS as string]
    : azureAdScopes;

export const nexusTeamsAzureAdScopes: string[] = (process.env.REACT_APP_AAD_API_SCOPE_NEXUS as string)
    ? [process.env.REACT_APP_AAD_API_SCOPE_NEXUS as string]
    : teamsAzureAdScopes;

export const browserMsalConfig: Configuration = {
    auth: {
        clientId: process.env.REACT_APP_AAD_CLIENT_ID as string,
        authority: process.env.REACT_APP_AAD_AUTHORITY as string,
        redirectUri: window.origin,
        postLogoutRedirectUri: window.origin,
    },
    cache: {
        cacheLocation: 'localStorage',
    },
    system: {
        allowRedirectInIframe: true,
        loggerOptions: {
            loggerCallback: (_level: LogLevel, _message: string, containsPii: boolean) => {
                if (containsPii) {
                    return;
                }
            },
            piiLoggingEnabled: false,
            logLevel: LogLevel.Warning,
        },
    },
};

// NAA: nested app auth using createNestablePublicClientApplication
export const teamsMsalConfig: Configuration = {
    auth: {
        clientId: process.env.REACT_APP_AAD_CLIENT_ID as string,
        authority: process.env.REACT_APP_AAD_AUTHORITY as string,
    },
    cache: {
        cacheLocation: 'localStorage',
    },
};

export const logoutRequest: EndSessionRequest = {
    postLogoutRedirectUri: window.location.origin,
};

export const msalLoginRequest = {
    scopes: azureAdScopes,
};
